<template>
  <div class="maintenance-status">
    <accordion-panel
      id="maintenance-status"
      :collapsed.sync="collapsed"
    >
      <template #title>
        {{ $t('engineering.cooling-maintenance.maintenance-status') }}
      </template>
      <s-empty-list
        v-if="showEmptyList"
        :loading="loading"
      />
      <div
        v-else
        class="maintenance-status__cards-wrapper"
      >
        <maintenance-status-card
          v-for="group in status"
          :key="group.id"
          :group="group"
        />
      </div>
    </accordion-panel>
  </div>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import MaintenanceStatusCard from '@/domain/components/installation/engineering/coolingMaintenance/general/MaintenanceStatusCard';

export default {
  name: 'MaintenanceStatusSection',
  components: { MaintenanceStatusCard, AccordionPanel },
  props: {
    status: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    collapsed: false,
  }),
  computed: {
    showEmptyList() {
      return this.loading || !this.status?.length;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.maintenance-status
  border: 1px solid $color-border-gray
  border-radius: 5px
  &__title
    background-color: var(--color-background-dark)
    text-align: left
    font-weight: bold
  &__cards-wrapper
    width: 100%
    display: grid
    gap: 18px
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))
    @media print
      display: block
  ::v-deep
    .accordion-panel
      box-shadow: none
      &__header
        padding: 2px 15px !important
        font-weight: bold
</style>
